import { inject } from 'tsyringe'
import { containerScoped } from '~/decorators/dependency-container'
import { Component } from 'vue'
import FreetextFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/FreetextFormHandler.vue'
import NumericFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/NumericFormHandler.vue'
import RichTextAreaFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/textarea/RichTextAreaFormHandler.vue'
import LookupFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/LookupFormHandler.vue'
import CategoryFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/category/CategoryFormHandler.vue'
import PasswordFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/PasswordFormHandler.vue'
import SubUserFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/SubUserFormHandler.vue'
import EmailFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/EmailFormHandler.vue'
import TelephoneFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/TelephoneFormHandler.vue'
import Location2FormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/location/Location2FormHandler.vue'
import ExtrasFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/ExtrasFormHandler.vue'
import PaymentFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/PaymentFormHandler.vue'
import TagsFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/TagsFormHandler.vue'
import ExternalLinkFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/ExternalLinkFormHandler.vue'
import PhotosFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/PhotosFormHandler.vue'
import LeasingExtrasFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/leasing/LeasingExtrasFormHandler.vue'
import ExternalCertificateFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/external-certificate/ExternalCertificateFormHandler.vue'
import YoutubeFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/YoutubeFormHandler.vue'
import LeasingOnlyFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/leasing/LeasingOnlyFormHandler.vue'
import LeasingOptionsFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/leasing/LeasingOptionsFormHandler.vue'
import KteoFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/KteoFormHandler.vue'
import TextAreaFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/textarea/TextAreaFormHandler.vue'
import EngineSizeFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/engine-details/EngineSizeFormHandler.vue'
import EnginePowerFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/engine-details/EnginePowerFormHandler.vue'
import MakeModelFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/makemodel/MakeModelFormHandler.vue'
import MonthAndYearFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/MonthAndYearFormHandler.vue'
import ExtraPaidServicesFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/rentals/ExtraPaidServicesFormHandler.vue'
import PickupLocationFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/rentals/PickupLocationFormHandler.vue'
import PricePerMonthFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/price/PricePerMonthFormHandler.vue'
import NumericStepFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/NumericStepFormHandler.vue'
import TradesSettingsFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/trades/TradesSettingsFormHandler.vue'
import OnlyTradesFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/trades/OnlyTradesFormHandler.vue'
import InsuranceFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/rentals/InsuranceFormHandler.vue'
import DiscountFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/rentals/DiscountFormHandler.vue'
import GoogleLocationFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/location/GoogleLocationFormHandler.vue'
import GooglePostcodeFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/location/GooglePostcodeFormHandler.vue'
import GoogleGeolocationFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/location/GoogleGeolocationFormHandler.vue'
import DateFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/DateFormHandler.vue'
import MultilingualTextAreaFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/textarea/MultilingualTextAreaFormHandler.vue'
import SubLocationsFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/location/SubLocationsFormHandler.vue'
import FreetextMakeModelFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/makemodel/FreetextMakeModelFormHandler.vue'
import CustomKeyValuesFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/CustomKeyValuesFormHandler.vue'
import TireFieldFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/TireFieldFormHandler.vue'
import ForMakeModelsFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/makemodel/ForMakeModelsFormHandler.vue'
import AuditsFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/external-certificate/AuditsFormHandler.vue'
import VueI18n from 'vue-i18n'
import { CategoryId } from '~/models/category/types'
import FinanceOptionsFormHandler from '~/components/car/classifieds/form/fieldsets/fields/handlers/FinanceOptionsFormHandler.vue'

@containerScoped()
export default class FormComponentService {
  constructor(@inject(VueI18n) private i18n: VueI18n) {}

  getFieldComponent(type: string): Component | null {
    switch (type) {
      case 'free_text_title':
      case 'name_field':
      case 'text':
      case 'external_classified_link_path':
      case 'variant':
      case 'real_estate_optional_title':
      case 'part_number_field':
      case 'external_id_field': {
        return FreetextFormHandler
      }
      case 'description_field':
      case 'text_area': {
        return TextAreaFormHandler
      }
      case 'years_of_experience_field':
      case 'minimum_years_of_experience_field':
      case 'fuel_efficiency_mixed':
      case 'fuel_efficiency_motorway':
      case 'fuel_efficiency_city':
      case 'circulation_tax_field':
      case 'battery_quick_charge_time_field':
      case 'battery_charge_time_field':
      case 'battery_capacity_field':
      case 'battery_range_field':
      case 'emissions_co2':
      case 'mileage_field':
      case 'fuel_efficiency_field':
      case 'numeric':
      case 'liters_field':
      case 'weight_field':
      case 'salary_field':
      case 'price_field':
      case 'car_price_field':
      case 'price_parked_field':
      case 'multi_child_price_field':
      case 'engine_power_field':
      case 'length_field':
      case 'facade_length': {
        return NumericFormHandler
      }
      case 'rich_description_field': {
        return RichTextAreaFormHandler
      }
      // TODO: re-enable this field in case of raw (non-rich) description field in the future and create a handler
      // description_field has no mapping, deprecated
      // case 'description_field': {
      //   return null
      // }
      // TODO determine if one 'lookup' or 'look_up' is unused
      case 'lookup':
      case 'number_plate_ending_field':
      case 'crashed_field':
      case 'floor_field':
      case 'look_up':
      case 'job_type_field':
      case 'exterior_color_field':
      case 'condition_field':
      case 'offertype_field':
      case 'euroclass':
      case 'clothes_color_field':
      case 'shoes_color_field':
      case 'clothes_size_field':
      case 'shoes_size_field':
      case 'drive_type':
      case 'gearbox_type_field':
      case 'fuel_type_field':
      case 'model_variant_field':
      case 'finance_field':
      case 'distance_field': {
        return LookupFormHandler
      }
      case 'jobs_category_field':
      case 'rental_category_field':
      case 'real_estate_category_field':
      case 'part_category_field':
      case 'vehicle_category_field':
      case 'xyma_category_field': {
        return CategoryFormHandler
      }
      case 'password_field': {
        return PasswordFormHandler
      }
      case 'user_field': {
        return SubUserFormHandler
      }
      case 'email_field': {
        return EmailFormHandler
      }
      case 'telephone_field': {
        return TelephoneFormHandler
      }
      case 'location2': {
        return Location2FormHandler
      }
      case 'finance_options_field': {
        return FinanceOptionsFormHandler
      }
      case 'job_extras_field':
      case 'rental_vehicle_extras':
      case 'vehicle_specials':
      case 'specials': {
        return ExtrasFormHandler
      }

      case 'payment_field': {
        return PaymentFormHandler
      }
      case 'tags_field':
      case 'xyma_tags':
      case 'tags':
      case 'job_tags':
      case 'text_array': {
        return TagsFormHandler
      }
      case 'youtube_link': {
        return YoutubeFormHandler
      }
      case 'buy_it_link':
      case 'external_classified_link':
      case 'external_link': {
        return ExternalLinkFormHandler
      }
      case 'photos2':
      case 'rental_photos_field': {
        return PhotosFormHandler
      }
      case 'external_certificate_field': {
        return ExternalCertificateFormHandler
      }
      case 'audits_field': {
        return AuditsFormHandler
      }
      case 'leasing_extras_field': {
        return LeasingExtrasFormHandler
      }
      case 'only_leasing_field': {
        return LeasingOnlyFormHandler
      }
      case 'leasing_options_field': {
        return LeasingOptionsFormHandler
      }
      case 'vehicle_kteo': {
        return KteoFormHandler
      }
      case 'engine_size_field': {
        return EngineSizeFormHandler
      }
      case 'engine_power': {
        return EnginePowerFormHandler
      }
      case 'make_model': {
        return MakeModelFormHandler
      }
      case 'vehicle_registration': {
        return MonthAndYearFormHandler
      }
      case 'rental_price_field': {
        return PricePerMonthFormHandler
      }
      case 'rental_extra_services': {
        return ExtraPaidServicesFormHandler
      }
      case 'rental_pickup_location_field': {
        return PickupLocationFormHandler
      }
      case 'numeric_step': {
        return NumericStepFormHandler
      }
      case 'trades_settings_field': {
        return TradesSettingsFormHandler
      }
      case 'only_trades_field': {
        return OnlyTradesFormHandler
      }
      case 'insurance_field': {
        return InsuranceFormHandler
      }
      case 'rental_discount_field': {
        return DiscountFormHandler
      }
      case 'address_field': {
        return GoogleLocationFormHandler
      }
      case 'postcode': {
        return GooglePostcodeFormHandler
      }
      case 'lat_lon': {
        return GoogleGeolocationFormHandler
      }
      case 'location': {
        return SubLocationsFormHandler
      }
      // TODO: check if this name is too generic and maybe change
      case 'visibility_field':
      case 'home_delivery_field':
      case 'offers_enabled_field':
      case 'boolean': {
        return LookupFormHandler
      }
      case 'date': {
        return DateFormHandler
      }
      case 'translated_text_area': {
        return MultilingualTextAreaFormHandler
      }
      case 'free_text_make_model': {
        return FreetextMakeModelFormHandler
      }
      case 'for_make_models': {
        return ForMakeModelsFormHandler
      }
      case 'custom_key_value_array': {
        return CustomKeyValuesFormHandler
      }
      case 'tire_field': {
        return TireFieldFormHandler
      }
      default: {
        return null
      }
    }
  }

  getPlaceholder(name: string, catIds: number[]): string {
    if (name === 'length' && catIds.includes(CategoryId.BOATS)) {
      return this.i18n
        .t('e.g. 5.5 meters = 5500')
        .toString()
        .toLowerCase()
    }

    return ''
  }
}
